import updateProduct from './colorSwatch';
import addQuickMobile from './mobileQuickAdd';
import sizeAddToCart from './sizeAddtoCart';

export class ProductCard {
  constructor($el) {
    this.$card = $el;
  }

  init() {
    this.bindEvents();
  }

  handleColorSwatch(event) {
    updateProduct(event);
  }

  handleMobileQuickAdd() {
    addQuickMobile();
  }

  handleSizesAddtoCart() {
    sizeAddToCart();
  }

  bindEvents() {
    sessionStorage.removeItem('product_list');

    this.handleMobileQuickAdd();
    // this.handleSizesAddtoCart();

    const $body = $('body');
    $body.on('click', '.product-colour-link', this.handleColorSwatch);
  }
}
